<template>
  <div class="account">
    <div class="title">
      <div v-if="!isAbroad">{{$t(langKey+'.title1')}}</div>
      <div v-if="isAbroad">{{$t(langKey+'.title2')}}</div>
    </div>
    <div class="input-group">
      <div class="input-wrap">
        <v-input class="input" :placeholder="$t(langKey+'.placeholder1')" v-model="username" @blur="usernameBlur"/>
      </div>
      <div class="input-wrap">
        <v-input class="input" v-if="!isAbroad" :placeholder="$t(langKey+'.placeholder2')" v-model="account" @blur="accountBlur"/>
        <v-input class="input" v-if="isAbroad" :placeholder="$t(langKey+'.placeholder3')" v-model="account" @blur="accountBlur"/>
      </div>
    </div>
    <div class="btn-submit">
      <a v-if="pass" class="active" @click="_bindPayAccount">{{$t(langKey+'.button')}}</a>
      <a v-if="!pass" class="disabled">{{$t(langKey+'.button')}}</a>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { setTitle } from 'components/mixin/title'
import { getPayAccount, bindPayAccount } from 'api/me'
import { MessageBox } from 'mint-ui'
import { mapGetters } from 'vuex'
import vInput from 'components/input'
export default {
  data() {
    return {
      langKey: this.$route.name,
      username: '',
      account: '',
      pass: false
    }
  },
  computed: {
    ...mapGetters(['lang', 'isAbroad', 'userInfo'])
  },
  created() {
    // 有联系方式才发送请求
    if (this.userInfo.mobile || this.userInfo.email) {
      this._getPayAccount()
    }
  },
  methods: {
    _getPayAccount() {
      this.$loading.open()
      let contact = this.isAbroad ? this.userInfo.email : this.userInfo.mobile
      getPayAccount(contact).then(res => {
        let data = res.data
        this.username = data.pay_account_name
        this.account = data.pay_account
        this.$loading.close()
      }).catch(err => {
        console.log(err)
        MessageBox.alert(err.msg)
        this.$loading.close()
      })
    },
    _bindPayAccount() {
      this.$loading.open()
      bindPayAccount({
        contact: this.isAbroad ? this.userInfo.email : this.userInfo.mobile,
        pay_account: this.account,
        name: this.username
      }).then(res => {
        this.$loading.close()
        let data = res.data
        console.log(data)
        this.$toast(this.$t(this.langKey + '.msg1'))
        setTimeout(() => {
          this.$router.replace('/me')
        }, 2500)
      }).catch(err => {
        console.log(err)
        MessageBox.alert(err.msg)
        this.$loading.close()
      })
    },
    checkForm() {
      // 判断是国内设备还是国外设备
      if (!this.isAbroad) {
        // 中国设备
        let regUsername = /^[\u4e00-\u9fa5]+(·[\u4e00-\u9fa5]+)*$/
        let regAccount = /(^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$)|(^(13[0-9]|14[5-9]|15[0-3,5-9]|16[2,5,6,7]|17[0-8]|18[0-9]|19[1,3,5,8,9])\d{8}$)/
        if (!regUsername.test(this.username)) {
          this.pass = false
        } else if (!regAccount.test(this.account)) {
          this.pass = false
        } else {
          this.pass = true
        }
      } else {
        // 国外设备
        let regAccount = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
        if (!this.username) {
          this.pass = false
        } else if (!regAccount.test(this.account)) {
          this.pass = false
        } else {
          this.pass = true
        }
      }
    },
    usernameBlur() {
      // 如果是中文设备
      if (!this.isAbroad) {
        let reg = /^[\u4e00-\u9fa5]+(·[\u4e00-\u9fa5]+)*$/
        if (!reg.test(this.username)) {
          this.$toast(this.$t(this.langKey + '.errorMsg2'))
        }
      } else {
        if (!this.username) {
          this.$toast(this.$t(this.langKey + '.errorMsg1'))
        }
      }
    },
    accountBlur() {
      let reg
      // 如果是中文设备
      if (!this.isAbroad) {
        reg = /(^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$)|(^(13[0-9]|14[5-9]|15[0-3,5-9]|16[2,5,6,7]|17[0-8]|18[0-9]|19[1,3,5,8,9])\d{8}$)/
      } else {
        reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
      }
      if (!reg.test(this.account)) {
        this.$toast(this.$t(this.langKey + '.errorMsg4'))
      }
    }
  },
  mixins: [setTitle],
  components: {
    vInput
  },
  watch: {
    userInfo() {
      this._getPayAccount()
    },
    username() {
      this.checkForm()
    },
    account() {
      this.checkForm()
    }
  }
}
</script>
<style scoped lang="scss">
  @import "css/def";
  .account{
    min-height: 100vh;
    background: #fff;
    color: #333;
    >.title{
      height: size(300);
      @include flex();
      font-size: size(48);
      padding: size(32);
    }
    >.input-group{
      padding: 0 size(32);
      .input-wrap{
        padding: 0 size(32);
        height: size(94);
        -webkit-border-radius: size(46);
        -moz-border-radius: size(46);
        border-radius: size(46);
        margin-bottom: size(40);
        @include flex();
        background-color: #f1f1f1;
        .input{
          width: 100%;
          /deep/ input{
            background-color: transparent;
            font-size: size(28);
          }
        }
      }
    }
    .btn-submit{
      >a {
        background-color: #E58B86;
        &.active{
          background-color: #D9251D;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/me/account.vue